module.exports = __webpack_public_path__ + "a5283fc60ba89275404551a41ebb142f.png";